import { ColumnKey } from "@faire/retailer-visitor-shared/features/PointOfSale/components/BulkEditor/BulkEditorColumns";
import { CLOVER, SHOPIFY, SQUARE } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useCallback } from "react";
export var useFAQFieldLabels = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return useCallback(// Disabling complexity here since this is meant to have many cases
    // eslint-disable-next-line complexity
    function(key, posType) {
        switch(key){
            case ColumnKey.TITLE:
                return posType === SHOPIFY ? strictLocalize({
                    id: "8MEenJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Product title"
                        }
                    ]
                }) : strictLocalize({
                    id: "5/gqi8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Product name"
                        }
                    ]
                });
            case ColumnKey.IMAGE:
                return strictLocalize({
                    id: "+TbxS0",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Product images"
                        }
                    ]
                });
            case ColumnKey.DESCRIPTION:
                return strictLocalize({
                    id: "tPDXXq",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Product description"
                        }
                    ]
                });
            case ColumnKey.BRAND:
                return strictLocalize({
                    id: "cHPVUE",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Vendor"
                        }
                    ]
                });
            case ColumnKey.PRODUCT_TYPE:
                return posType === SHOPIFY ? strictLocalize({
                    id: "7GcwHC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Product type"
                        }
                    ]
                }) : strictLocalize({
                    id: "pIq7NH",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Category"
                        }
                    ]
                });
            case ColumnKey.CATEGORIES:
                return strictLocalize({
                    id: "VLjPxS",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Categories"
                        }
                    ]
                });
            case ColumnKey.COLLECTIONS:
                return strictLocalize({
                    id: "8nuxKB",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Collections"
                        }
                    ]
                });
            case ColumnKey.TAGS:
                return strictLocalize({
                    id: "CzMcdx",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Tags"
                        }
                    ]
                });
            case ColumnKey.PRINTER_LABEL:
                return strictLocalize({
                    id: "ha5kim",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Printer labels"
                        }
                    ]
                });
            case ColumnKey.REVENUE_CLASS:
                return strictLocalize({
                    id: "3crgMd",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Revenue classes"
                        }
                    ]
                });
            case ColumnKey.COST_PER_ITEM:
                return posType === SQUARE ? "" : strictLocalize({
                    id: "JDBuC1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Cost per item"
                        }
                    ]
                });
            case ColumnKey.RETAIL_PRICE:
                return strictLocalize({
                    id: "AV7Ywa",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Retail price"
                        }
                    ]
                });
            case ColumnKey.SKU:
                return strictLocalize({
                    id: "dn1fr9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "SKU"
                        }
                    ]
                });
            case ColumnKey.BARCODE:
                switch(posType){
                    case SQUARE:
                        return strictLocalize({
                            id: "oFuI1F",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "GTIN"
                                }
                            ]
                        });
                    case CLOVER:
                        return strictLocalize({
                            id: "RM7+/c",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Product code"
                                }
                            ]
                        });
                    case SHOPIFY:
                    default:
                        return strictLocalize({
                            id: "yODb4S",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Barcode"
                                }
                            ]
                        });
                }
            case ColumnKey.STATUS:
                return strictLocalize({
                    id: "YWz8f8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Status"
                        }
                    ]
                });
            case ColumnKey.TAXABLE:
                return strictLocalize({
                    id: "XWHrkk",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Taxable"
                        }
                    ]
                });
            case ColumnKey.SHIPPING_WEIGHT:
                return strictLocalize({
                    id: "zvARNC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shipping weight"
                        }
                    ]
                });
            case ColumnKey.REPORTING_CATEGORY:
                return strictLocalize({
                    id: "8GZ1L7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reporting category"
                        }
                    ]
                });
            case ColumnKey.TAXES:
                return posType === SQUARE ? strictLocalize({
                    id: "mfd1z4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Tax types"
                        }
                    ]
                }) : strictLocalize({
                    id: "dxHG29",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Taxes"
                        }
                    ]
                });
            case ColumnKey.CHECKBOX:
            case ColumnKey.PRODUCT_ORGANIZATION:
            case ColumnKey.PRICING:
            case ColumnKey.SHIPPING:
            case ColumnKey.SHIPPING_REQUIRED:
            case ColumnKey.CATEGORIZATION:
            case ColumnKey.SALES_TAXES:
                return "";
            default:
                return exhaustiveSwitchWithDefault("")(key);
        }
    }, [
        strictLocalize
    ]);
};
